import {gsap} from "gsap";


const bgAnimation = gsap.timeline({paused: true})
    .addLabel('step1')
    .from('.p-sec1__bg-item--2', { duration: 5, x: 70}, 'step1+=0.3')
    .from('.p-sec1__bg-item--3', { duration: 5, opacity: 0.7, x: -70}, 'step1+=0.3')
    .from('.p-sec1__bg-item--4', { duration: 5, x: 70}, 'step1+=0.3')
    .from('.p-sec1__bg-item--5', { duration: 3, opacity: 0}, 'step1+=0.5')

const mainAnimation = gsap.timeline({paused: true})
    .addLabel('step1')
    .from('.p-sec1__title-sub', { duration: 1, y: 50, opacity: 0, ease: 'power2.out'}, 'step1+=0.5')
    .from('.p-sec1__title-main', { duration: 1, y: 50, opacity: 0, ease: 'power2.out'}, '-=0.8')
    .from('.p-sec1__text1', { duration: 1, y: 50, opacity: 0, ease: 'power2.out'}, '-=0.8')
    .addLabel('step2', '+=0')
    .from('.p-sec1__btn-play', { duration: 1, y: 50, opacity: 0, ease: 'power2.out'}, 'step2+=0.2')
    .from('.p-sec1__btn-scroll', { duration: 1, y: 50, opacity: 0, ease: 'power2.out'}, 'step2+=0.2')
    .from('.p-sec1__text2', { duration: 1, y: 50, opacity: 0, ease: 'power2.out'}, 'step2+=0.4')
    .from('.p-sec1__banner', { duration: 1, x: 50, opacity: 0, ease: 'power2.out'}, 'step2+=0.4')
    .from('.p-sec1__util', { duration: 1, x: 50, opacity: 0, ease: 'power2.out'}, 'step2+=0.4')

const charAnimation = gsap.timeline({paused: true})
    .addLabel('step1')
    .from('.character__left-item--1', { duration: 1, x: 75, ease: 'power4.out'}, 'step1+=0.7')
    .from('.character__left-item--1', { duration: 1.5, opacity: 0, ease: 'power1.out'}, 'step1+=0.7')
    .from('.character__right-item--3', { duration: 1, x: -75, ease: 'power4.out'}, 'step1+=0.7')
    .from('.character__right-item--3', { duration: 1.5, opacity: 0, ease: 'power1.out'}, 'step1+=0.7')
    .from('.character__center-item--1', { duration: 1, y: 100, ease: 'power4.out'}, 'step1+=0.8')
    .from('.character__center-item--1', { duration: 1.5, opacity: 0, ease: 'power1.out'}, 'step1+=0.9')

    .from('.character__left-item--2', { duration: 1, scale: 0, opacity: 0, ease: 'power4.out'}, 'step1+=1.2')
    .from('.character__right-item--1', { duration: 1, scale: 0, opacity: 0, ease: 'power4.out'}, 'step1+=1.3')
    .from('.character__right-item--4', { duration: 1, scale: 0, opacity: 0, ease: 'power4.out'}, 'step1+=1.2')
    .from('.character__right-item--2', { duration: 1, scale: 0, opacity: 0, ease: 'power4.out'}, 'step1+=1.4')

export default {
    id: '#section-1',
    name: 'MAIN',
    enterStart() {
        gsap.fromTo('.p-sec1__bg-item--1', { backgroundSize: '100% 100%' },{ duration: 10, backgroundSize: '110% 110%' });
        bgAnimation.seek(0);
        bgAnimation.play();
        mainAnimation.seek(0);
        mainAnimation.play();
        charAnimation.seek(0);
        charAnimation.play();
    },
    leaveStart() {

    }
};


// WEBPACK FOOTER //
// ./src/js/pc/section1.js